import { getCookieByKey, removeTokenByKey, setTokenByKey } from "@/libs/util";

export default {
  state: {
    client_id: "citswx",
    ticket: ""
  },
  getters: {},
  mutations: {
    setTicket(state, ticket) {
      state.ticket = ticket;
    },
    setCookie(state) {
      let infojson = {
        ticket: state.ticket
      };
      let cookiedt = {
        cookiekey: "wcits",
        cookievalue: JSON.stringify(infojson)
      };
      setTokenByKey(cookiedt);
    }
  }
};
